module.exports = __webpack_public_path__ + "img/ic_edit.86594ca7.svg";